import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import useUserData from 'src/hooks/useUserData'

class BaseRequest {
  protected api: AxiosInstance
  constructor() {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL as string,
    })
    this.attachInterceptors()
  }
  private attachInterceptors() {
    this.api.interceptors.request.use((req: AxiosRequestConfig) => {
      try {
        const USER_DATA: any = useUserData()
        const token = USER_DATA.authorization.token
        if (token) {
          if (req.headers) {
            req.headers.Authorization = `Bearer ${token}`
          }
        }
      } catch {
        // do nothing
      }
      return req
    })

    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.message === 'Network Error' && !error.response) {
        }
      }
    )
  }
}
export default BaseRequest
